// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__3mk8F","app__chat":"app_app__chat__1jYfQ","app__sidebar":"app_app__sidebar__-6xVV"};